import dayjs from "dayjs";
import { buildDayjs } from "@metriport/shared/common/date";

export const ISO_DATE = "YYYY-MM-DD";
const DATETIME_FORMAT = "MMM D, YYYY h:mm A";
const DATETIME_NO_YEAR_FORMAT = "MMM D, h:mm A";

export const formatDateTime = (date: Date | null | undefined): string => {
  if (!date) return "-";
  return buildDayjs(date).format(DATETIME_FORMAT);
};

export const formatDateTimeInLocal = (date: Date | null | undefined): string => {
  if (!date) return "-";
  return dayjs(date).format(DATETIME_FORMAT);
};

export const formatDateTimeInLocalNoYear = (date: Date | null | undefined): string => {
  if (!date) return "-";
  return dayjs(date).format(DATETIME_NO_YEAR_FORMAT);
};

export function formatFilterIfDateInput(input: string): string {
  // MM-DD-YYYY or MM/DD/YYYY → YYYY-MM-DD
  const mmDdYyyyPattern = /^(\d{2})[-/](\d{2})[-/](\d{4})$/;
  const mmDdMatch = input.match(mmDdYyyyPattern);
  if (mmDdMatch) {
    const [, month, day, year] = mmDdMatch;
    return `${year}-${month}-${day}`;
  }
  // YYYY/MM/DD → YYYY-MM-DD
  const yyyyMmDdSlashPattern = /^(\d{4})\/(\d{2})\/(\d{2})$/;
  const yyyyMatch = input.match(yyyyMmDdSlashPattern);
  if (yyyyMatch) {
    const [, year, month, day] = yyyyMatch;
    return `${year}-${month}-${day}`;
  }
  return input;
}
